import { Component, ChangeDetectionStrategy } from '@angular/core'
import { Translations } from '../localization/translations'

@Component({
  selector: 'alliance-shared-ui-new-badge',
  templateUrl: './new-badge.component.html',
  styleUrls: ['./new-badge.component.tw.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewBadgeComponent {
  public constructor(public translation: Translations) {}
}
